import Web3 from 'web3'

function getWindowObject() {
  return typeof window === 'undefined' ? undefined : window
}

export function getEthereum() {
  const currentWindow = getWindowObject()
  return currentWindow ? currentWindow.ethereum : undefined
}

export function getWeb3() {
  const ethereum = getEthereum()
  return ethereum ? new Web3(ethereum) : null
}
